import React from 'react';
import './EInvoice.css';
import {withRouter} from "react-router";
import CruiseDetails from "../cruise-details/cruise-details";
import LandDetails from "../land-details/land-details";
import InvoiceDetails from "../invoice-details/invoice-details";
import TravelProtectionDetails from "../travel-protection-details/travel-protection-details";
import Helmet from "react-helmet/es/Helmet";

class EInvoice extends React.Component {

    constructor(props) {
        super(props);
        const {enc} = this.props.match.params;
        this.franchiseData = this.props.franchiseData;
        this.state = {
            booking: null,
            errorMessage: 'We’re sorry. Your booking cannot be displayed at this time.' //this is the default message...
        }
        this.getInvoice(enc);
    }

    getInvoice(enc) {
        let url = '/wthrest/customer-self-service/getInvoice.rs';
        let payload = {
            "encryptedParameter": enc
        };

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(invoiceResponse => {
            if (invoiceResponse.status === 200) {
                return invoiceResponse.json()
            } else {
                const msg = invoiceResponse.headers.get('X-Error-Message');
                this.setState({errorMessage: msg});
                this.setState({error: true});
            }
        }).catch(error => {
            this.setState({errorMessage: 'We’re sorry. Your booking cannot be displayed at this time.'});
            this.setState({error: true});
        }).then(jsonInvoiceResponse => {
            this.setState({invoice: jsonInvoiceResponse})
        }).catch(error => {
            this.setState({errorMessage: 'We’re sorry. Your booking cannot be displayed at this time.'});
            this.setState({error: true});
        });
    }

    render = () => {
        return (
            <div>
                {this.state.invoice && !this.state.invoice.sendGoogleAnalytics &&
                <Helmet>
                    <title>Customer Self Service</title>
                    <script>
                        {`
                            window.dataLayer = window.dataLayer || [];
                            try{
                                dataLayer.push({         
                                    'gaProperty': '` + this.franchiseData.gaPropertyId + `',
                                    'dimension37': '` + this.franchiseData.agencyName + `',
                                    'dimension38': '` + this.franchiseData.agencyId + `',                       
                                    'event': 'VirtualPageview',
                                    'virtualPageURL': 'gaVirtualPageURL',
                                    'virtualPagePath': '/einvoice/eimain',
                                    'virtualPageTitle' : 'eInvoice'
                            });
                            } catch(error){
                                //swallow error
                            }
                        `}
                    </script>
                    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-20449983-5"></script>
                    <script>
                        {`
                            function gtag(){dataLayer.push(arguments);}
                            var gaPathName = "";
                            function changeGaPageviewUrl(){
                                var gaPathName =  window.location.pathname.split('?')[0];
                                //put the next line only for homepages to clean up the URL
                                gaPathName = gaPathName.replace("HomePage.html", "");
    
                                if (window.location.search) {
                                    var cleanURL = window.location.search;
                                    cleanURL = cleanURL.slice(1);
                                    var query = cleanURL;
                                    var argParam = false;
                                    for(var k=0; k < arguments.length; k++) {
                                        if (query.search(arguments[k]) > -1) {
                                            argParam = true;
                                            break;
                                        }
                                    }
        
                                    if (argParam) {
                                        var vars = query.split("&");
                                        for (var i = 0; i < vars.length; i++) {
                                            var pair = vars[i].split("=");
                
                                            for(var j=0; j < arguments.length; j++)
                                                if (pair[0].search(arguments[j]) > -1) {
                                                    vars[i] = pair[0] + "=";
                                                } 
                                        }
        
                                        return gaPathName + "?" + vars.join("&");
                                    } else {
                                        return gaPathName + "?" + query;
                                      }
                                } else {
                                    return gaPathName;
                                  }
                            }

                            var gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname + changeGaPageviewUrl("email", "zip", "zipcode", "shoppingZipCode");

                            gtag('js', new Date());
                            gtag('config', 'UA-20449983-5',{ 
                                'send_page_view': false,
                                'page_location': gaGTAGPageURL,
                                'page_path':gaPathName
                            });

                            function CallTracker(category, action, label, value, noninteraction) {
                                if(label == "" || label == null) {
                                    label = "(not set)";
                                } 
                                gtag('event', action, {
                                    'event_category': category,
                                    'event_label': label,
                                    'value': value
                                });
                            }

                            function CallTrackerNonInteraction(category, action, label, value, noninteraction) {
                                if(label == "" || label == null) {
                                    label = "(not set)";
                                }
                                gtag('event', action, {
                                    'event_category': category,
                                    'event_label': label,
                                    'value': value,
                                    'non_interaction': true
                                });
                            }

                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-5WDH3K');
                        `}
                    </script>
                </Helmet>
                }
                {this.state.invoice && this.state.invoice.sendGoogleAnalytics &&
                <Helmet>
                    <title>Customer Self Service</title>
                    <script>
                        {`
                            window.dataLayer = window.dataLayer || [];
                            try{
                                dataLayer.push({
                                'productType': '` + this.state.invoice.bookingTyoe + `', 
                                'bookingSite': '` + window.location + `',
                                'bookingDate': '` + new Date() + `',
                                'bookingChannel': 'Offline',                                
                                'gaProperty': '` + this.franchiseData.gaPropertyId + `',
                                'dimension37': '` + this.franchiseData.agencyName + `',
                                'dimension38': '` + this.franchiseData.agencyId + `',                                                               
                                'bookingInsurance':'N/A',
                                'paymentOption':'N/A',                                
                                'searchedDestination': 'N/A',
                                'searchedCruiseLength': 'N/A',
                                'searchedCruiseLine': 'N/A',
                                'searchedCruiseShip': 'N/A',
                                'searchedDeparturePort': 'N/A',
                                'searchedDepartureMonth': 'N/A',
                                'searchedDepartureDay': 'N/A',
                                'searchedFlexDate': 'N/A',
                                'searchedMonthsOut': 'N/A',
                                'searchedResidentDiscount': 'N/A',
                                'searchedSeniorDiscount': 'N/A',
                                'searchedPastGuestDiscount': 'N/A',
                                'searchedPastGuestList': 'N/A',
                                'ecommerce': {
                                    'currencyCode': 'USD',
                                    'purchase': {
                                        'actionField': {
                                            'id': '` + this.state.invoice.bookingId + `',
                                            'affiliation': '',
                                            'revenue': '0',
                                            'tax':'',
                                            'shipping': '',
                                            'coupon': ''
                                        },
                                        'products': [{
                                            'name': '` + this.state.invoice.itineraryDescription + `',
                                            'id': '',
                                            'price': '0',
                                            'brand': '` + this.state.invoice.supplierName + `',
                                            'category': '',
                                            'variant': '` + this.state.invoice.shipName + `',
                                            'quantity': '` + this.state.invoice.guests.length + `',    
                                            'coupon': '',
                                            'dimension6':'N/A',
                                            'dimension7':'` + this.state.invoice.tripStartDate + `',    
                                            'dimension8':'` + this.state.invoice.categoryDescription + `',
                                            'dimension8':'` + this.state.invoice.cabinNumber + `',
                                            'dimension10':'N/A',
                                            'dimension11':'` + this.state.invoice.embarkationPort + `',
                                            'dimension12':'N/A',
                                            'dimension13':'N/A',                                            
                                            'dimension15':'N/A', 
                                            'dimension17':'N/A',
                                            'dimension18':'N/A',
                                            'dimension19':'N/A',
                                            'dimension20':'N/A',
                                            'dimension21':'N/A'
                                        }]
                                    }
                                },
                                'event': 'VirtualPageview',
                                'virtualPageURL': 'gaVirtualPageURL',
                                'virtualPagePath': '/einvoice/eimain',
                                'virtualPageTitle' : 'eInvoice'
                            });
                            } catch(error){
                                //swallow error
                            }
                        `}
                    </script>
                    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-20449983-5"></script>
                    <script>
                        {`
                            function gtag(){dataLayer.push(arguments);}
                            var gaPathName = "";
                            function changeGaPageviewUrl(){
                                var gaPathName =  window.location.pathname.split('?')[0];
                                //put the next line only for homepages to clean up the URL
                                gaPathName = gaPathName.replace("HomePage.html", "");
    
                                if (window.location.search) {
                                    var cleanURL = window.location.search;
                                    cleanURL = cleanURL.slice(1);
                                    var query = cleanURL;
                                    var argParam = false;
                                    for(var k=0; k < arguments.length; k++) {
                                        if (query.search(arguments[k]) > -1) {
                                            argParam = true;
                                            break;
                                        }
                                    }
        
                                    if (argParam) {
                                        var vars = query.split("&");
                                        for (var i = 0; i < vars.length; i++) {
                                            var pair = vars[i].split("=");
                
                                            for(var j=0; j < arguments.length; j++)
                                                if (pair[0].search(arguments[j]) > -1) {
                                                    vars[i] = pair[0] + "=";
                                                } 
                                        }
        
                                        return gaPathName + "?" + vars.join("&");
                                    } else {
                                        return gaPathName + "?" + query;
                                      }
                                } else {
                                    return gaPathName;
                                  }
                            }

                            var gaGTAGPageURL = window.location.protocol + "//" + window.location.hostname + changeGaPageviewUrl("email", "zip", "zipcode", "shoppingZipCode");

                            gtag('js', new Date());
                            gtag('config', 'UA-20449983-5',{ 
                                'send_page_view': false,
                                'page_location': gaGTAGPageURL,
                                'page_path':gaPathName
                            });

                            function CallTracker(category, action, label, value, noninteraction) {
                                if(label == "" || label == null) {
                                    label = "(not set)";
                                } 
                                gtag('event', action, {
                                    'event_category': category,
                                    'event_label': label,
                                    'value': value
                                });
                            }

                            function CallTrackerNonInteraction(category, action, label, value, noninteraction) {
                                if(label == "" || label == null) {
                                    label = "(not set)";
                                }
                                gtag('event', action, {
                                    'event_category': category,
                                    'event_label': label,
                                    'value': value,
                                    'non_interaction': true
                                });
                            }

                            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                            '//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                            })(window,document,'script','dataLayer','GTM-5WDH3K');
                        `}
                    </script>
                </Helmet>
                }
                {
                    this.state.error &&
                    <div className="text-center rea-errorMessage">
                        {this.state.errorMessage} Please call {this.franchiseData.mainPhoneNumber} to speak with your
                        vacation specialist for assistance.
                    </div>
                }
                {
                    !this.state.error && !this.state.invoice &&
                    <div className="text-center rea-loadingContainer">
                        <div className="rea-loadingText">
                            Loading Invoice
                        </div>
                        <div className="rea-ldsEllipsis">
                            <div></div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                }
                {
                    !this.state.error && this.state.invoice &&
                    <div className="rea-EInvoice">
                        <div className="rea-block-row">
                            <div className="rea-block-12">
                                <div className="rea-block-row rea-pageHeader">
                                    <div className="rea-block-6">
                                        <div className="rea-pageHeaderTitle">BOOKING SUMMARY</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="rea-block-row rea-invoiceDetailsContainer">
                            <div className="rea-block-12">
                                <div className="rea-block-row">
                                    <div className="rea-block-12 rea-bookingDetailsBlock rea-mobile-padding-0">
                                        {(this.state.invoice.bookingType.toLowerCase() === 'cruise' &&
                                            <CruiseDetails booking={this.state.invoice}
                                                           showItineraryLink={false}/>) || (this.state.invoice.bookingType.toLowerCase() === 'land' &&
                                            <LandDetails booking={this.state.invoice} showItineraryLink={false}/>)}
                                    </div>
                                </div>
                            </div>
                            <div className="rea-block-12">
                                <div className="rea-block-row rea-invoicePayRow">
                                    <div className="rea-block-6 rea-invoiceDetailsCol">
                                        <InvoiceDetails invoice={this.state.invoice} showItineraryButton={true}
                                                        showInvoiceDisclaimer={false}/>
                                    </div>
                                    {
                                        this.showPaymentLink() &&
                                        <div className="rea-block-6">
                                            <div className="rea-block-row rea-onlinePayContainer">
                                                <div className="rea-block-12 rea-onlinePayTitle">
                                                    <div className="rea-sectionHeaders">Pay Online</div>
                                                </div>
                                                <div className="rea-block-12 rea-onlinePayDetails">
                                                    <div className="rea-onlinePayText">
                                                        Our convenient online portal is a quick and easy way to make a
                                                        payment
                                                        on your upcoming vacation.
                                                    </div>
                                                    <a className="btn wth2-ui-btn rea-onlinePayBtn"
                                                       href="/customer-self-service"><i
                                                        className="fa fa-credit-card"></i> Make
                                                        a Payment</a>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="rea-block-12">
                                <div className="rea-block-row">
                                    <div className="rea-block-12">
                                        <TravelProtectionDetails guests={this.state.invoice.guests}
                                                                 insuranceParagraph={this.state.invoice.insuranceParagraph}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
    showPaymentLink = () => {
        let allowOnlinePaymentsInSwapStoreCode = (this.franchiseData !== undefined && this.franchiseData.storeCodeFlags !== undefined && this.franchiseData.storeCodeFlags[0] !== undefined && this.franchiseData.storeCodeFlags[0].PCS === 'Y');
        return (this.state.invoice.allowOnlinePayments && allowOnlinePaymentsInSwapStoreCode);
    }
}

export default withRouter(EInvoice)
